<template>
    <div class="card-billing big-card-block block-card card-border ">
        <v-expansion-panel expand :value="panel">
            <v-expansion-panel-content :lazy="true">
                <template v-slot:header>
                    <div class="block-card-title handle">
                        <div class="title-icon">
                            <img src="../../../../assets/img/ic_gallery-sm.png" alt="">
                        </div>

                        <h4>Billing</h4>
                    </div>
                </template>
                <div class="block-card-body">
                    <v-layout row wrap>

                        <v-flex xs12>
                            <label>Title</label>
                            <!--                            <v-text-field-->
                            <!--                                    outline-->
                            <!--                                    v-model="data.title"-->
                            <!--                                    :error="!data.title"-->
                            <!--                                    :error-messages="!data.title? 'Title is Required':''"-->
                            <!--                            >-->
                            <!--                            </v-text-field>-->
                            <vTextareaAutocomplete v-model="data.title" :type="'textfield'"
                                                   :validationRules="autocompleteBillingValidationRules"></vTextareaAutocomplete>
                            <label>Image URL</label>
                            <!--                            <v-text-field-->
                            <!--                                    outline-->
                            <!--                                    v-model="data.image"-->
                            <!--                                    :error="!data.image || !common.validURL(data.image)"-->
                            <!--                                    :error-messages="!data.image? 'URL is Required':'' || !common.validURL(data.image)? 'URL is not valid':''"-->
                            <!--                            >-->
                            <!--                            </v-text-field>-->
                            <vTextareaAutocomplete v-model="data.image" :type="'textfield'"
                                                   :validationRules="autocompleteBillingValidationRules"></vTextareaAutocomplete>
                        </v-flex>

                        <v-flex xs12 v-if="data.first_row">
                            <div class="first-row mt-3">
                                <!--                                <v-text-field-->
                                <!--                                        outline-->
                                <!--                                        v-model="data.first_row.title"-->
                                <!--                                        :error="!data.first_row.title"-->
                                <!--                                        :error-messages="!data.first_row.title? 'title is Required':''"-->
                                <!--                                        placeholder="title"-->
                                <!--                                >-->
                                <!--                                </v-text-field>-->
                                <vTextareaAutocomplete v-model="data.first_row.title" :type="'textfield'"
                                                       :validationRules="autocompleteBillingValidationRules"></vTextareaAutocomplete>
                                <!--                                <v-text-field-->
                                <!--                                        outline-->
                                <!--                                        v-model="data.first_row.value"-->
                                <!--                                        :error="!data.first_row.value"-->
                                <!--                                        :error-messages="!data.first_row.value? 'value is Required':''"-->
                                <!--                                        placeholder="value"-->
                                <!--                                >-->
                                <!--                                </v-text-field>-->
                                <vTextareaAutocomplete v-model="data.first_row.value" :type="'textfield'"
                                                       :validationRules="autocompleteBillingValidationRules"></vTextareaAutocomplete>
                            </div>
                        </v-flex>

                        <v-flex
                                xs3
                                class="mt-4"
                                v-for="(row, index) in data.second_row"
                        >
                            <!--                            <v-text-field-->
                            <!--                                    outline-->
                            <!--                                    v-model="row.title"-->
                            <!--                                    :error="!row.title"-->
                            <!--                                    :error-messages="!row.title? 'title is Required':''"-->
                            <!--                                    placeholder="title"-->
                            <!--                            >-->
                            <!--                            </v-text-field>-->
                            <vTextareaAutocomplete v-model="row.title" :type="'textfield'"
                                                   :validationRules="autocompleteBillingValidationRules"></vTextareaAutocomplete>
                            <!--                            <v-text-field-->
                            <!--                                    outline-->
                            <!--                                    v-model="row.value"-->
                            <!--                                    :error="!row.value"-->
                            <!--                                    :error-messages="!row.value? 'value is Required':''"-->
                            <!--                                    placeholder="value"-->
                            <!--                            >-->
                            <!--                            </v-text-field>-->
                            <vTextareaAutocomplete v-model="row.value" :type="'textfield'"
                                                   :validationRules="autocompleteBillingValidationRules"></vTextareaAutocomplete>
                        </v-flex>

                        <v-flex
                                xs3
                                class="mt-4"
                                v-for="(item, index) in data.third_row"
                        >
                            <!--                            <v-text-field-->
                            <!--                                    outline-->
                            <!--                                    v-model="item.title"-->
                            <!--                                    :error="!item.title"-->
                            <!--                                    :error-messages="!item.title? 'title is Required':''"-->
                            <!--                                    placeholder="title"-->
                            <!--                            >-->
                            <!--                            </v-text-field>-->
                            <vTextareaAutocomplete v-model="item.title" :type="'textfield'"
                                                   :validationRules="autocompleteBillingValidationRules"></vTextareaAutocomplete>
                            <!--                            <v-text-field-->
                            <!--                                    outline-->
                            <!--                                    v-model="item.value"-->
                            <!--                                    :error="!item.value"-->
                            <!--                                    :error-messages="!item.value? 'value is Required':''"-->
                            <!--                                    placeholder="value"-->
                            <!--                            >-->
                            <!--                            </v-text-field>-->
                            <vTextareaAutocomplete v-model="item.value" :type="'textfield'"
                                                   :validationRules="autocompleteBillingValidationRules"></vTextareaAutocomplete>
                        </v-flex>

                        <v-flex v-if="data.fourth_row" class="mt-4" xs6>
                            <!--                            <v-text-field-->
                            <!--                                    outline-->
                            <!--                                    v-model="data.fourth_row.title"-->
                            <!--                                    :error="!data.fourth_row.title"-->
                            <!--                                    :error-messages="!data.fourth_row.title? 'title is Required':''"-->
                            <!--                                    placeholder="title"-->
                            <!--                            >-->
                            <!--                            </v-text-field>-->
                            <vTextareaAutocomplete v-model="data.fourth_row.title" :type="'textfield'"
                                                   :validationRules="autocompleteBillingValidationRules"></vTextareaAutocomplete>
                        </v-flex>
                        <v-flex v-if="data.fourth_row" class="mt-4" xs6>
                            <!--                            <v-text-field-->
                            <!--                                    outline-->
                            <!--                                    v-model="data.fourth_row.value"-->
                            <!--                                    :error="!data.fourth_row.value"-->
                            <!--                                    :error-messages="!data.fourth_row.value? 'value is Required':''"-->
                            <!--                                    placeholder="value"-->
                            <!--                            >-->
                            <!--                            </v-text-field>-->
                            <vTextareaAutocomplete v-model="data.fourth_row.value" :type="'textfield'"
                                                   :validationRules="autocompleteBillingValidationRules"></vTextareaAutocomplete>
                        </v-flex>

                        <v-flex class="mt-4" xs12>
                            <label>Speak</label>
                            <!--                            <v-text-field-->
                            <!--                                    outline-->
                            <!--                                    v-model="data.speak"-->
                            <!--                                    :error="!data.speak"-->
                            <!--                                    :error-messages="!data.speak? 'speak is Required':''"-->
                            <!--                            >-->
                            <!--                            </v-text-field>-->
                            <vTextareaAutocomplete v-model="data.speak" :type="'textfield'"
                                                   :validationRules="autocompleteBillingValidationRules"></vTextareaAutocomplete>
                        </v-flex>

                        <v-flex class="mt-4">

                            <v-radio-group row v-model="data.lang">
                                <label class="d-inline-block mr-4">Lang:</label>
                                <v-radio
                                        label="Ar"
                                        value="ar"
                                ></v-radio>
                                <v-radio
                                        label="En"
                                        value="en"
                                ></v-radio>
                            </v-radio-group>
                            <v-radio-group row v-model="data.horizontalAlignment">
                                <label class="d-inline-block mr-4">Lang:</label>
                                <v-radio
                                        label="Left"
                                        value="left"
                                ></v-radio>
                                <v-radio
                                        label="Right"
                                        value="right"
                                ></v-radio>
                            </v-radio-group>
                        </v-flex>

                    </v-layout>
                </div>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </div>
</template>

<script>
    import common from "../../../../utils/common"

    export default {
        name: "card-billing",
        props: {
            data: {
                type: Object,
                default: () => {
                    return {}
                }
            },
            index: {
                type: Number,
                default: () => {
                    return 0
                }
            },
            blocksList: {
                type: Array,
                default: () => {
                    return []
                }
            }
        },
        data() {
            return {
                valid: true,
                panel: 1,
                common,
                autocompleteBillingValidationRules: [
                    v => !!v || 'Value is Required'
                ]
            }
        },
        mounted() {

        },
        methods: {},
        computed: {},
        watch: {}
    }
</script>

<style scoped>

</style>